import { Component, computed, effect, inject, signal, WritableSignal } from '@angular/core';
import { AnalyseService } from '../../../services/analyse-service';
import { RsvpDataResponse } from '../../../dto/RsvpDataResponse';
import { ModificationHistoryLine } from '../../../models/ModificationHistoryLine';
import { DatePipe } from '@angular/common';
import { UpdateFamilyHistoryType } from '../../../models/UpdateFamilyHistoryType.enum';
import { DatepickerValue, NgxsmkDatepickerComponent } from 'ngxsmk-datepicker';

@Component({
  selector: 'app-notifications',
  imports: [DatePipe, NgxsmkDatepickerComponent],
  templateUrl: './notifications.html',
  styleUrl: './notifications.scss',
})
export class Notifications {

  activeTab: WritableSignal<0 | 1 | 2> = signal(0);
  private analyseService = inject(AnalyseService);

  readonly modificationsRange = signal<{ start: Date; end: Date } | null>(null);

  readonly startDate = computed(() => this.modificationsRange()?.start ?? null);
  readonly endDate = computed(() => this.modificationsRange()?.end ?? null);

  allFamiliesWithComments: WritableSignal<RsvpDataResponse[] | undefined> = signal(undefined);
  allFamiliesWithAnswers: WritableSignal<RsvpDataResponse[] | undefined> = signal(undefined);
  shownModifications: WritableSignal<ModificationHistoryLine[] | undefined> = signal(undefined);

  constructor() {
    effect(async () => {
      const start = this.modificationsRange()?.start ?? null;
      const end = this.modificationsRange()?.end ?? null;
      const tab = this.activeTab();

      if (tab === 0 && !this.allFamiliesWithComments()) {
        this.allFamiliesWithComments.set(await this.analyseService.getAllComments());
      } else if (tab === 1 && !this.allFamiliesWithAnswers()) {
        this.allFamiliesWithAnswers.set(await this.analyseService.getAllBonuQuestionAnswer());
      } else if (tab === 2) {
        this.analyseService.getAllModificationBetwin(start, end).then(response => {
          this.shownModifications.set(
            response.map(line => ({
              ...line,
              updateType: UpdateFamilyHistoryType.retrieveValueByKey(line.updateType)
            }))
          );
        });
      }
    });
  }

  datePickerValueChange($event: DatepickerValue) {
    const range = $event as { start: Date; end: Date } | null;
    this.modificationsRange.set(range);
    this.shownModifications.set(undefined);
  }

  selectFilterDate(daysToSubstract: 0 | 1 | 7): void {

    const endOfToday = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 99, 99);
    const startOfToday = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0);

    const ranges: Record<string, { start: Date; end: Date }> = {
      0: { start: startOfToday, end: endOfToday },
      1: { start: new Date(startOfToday.getTime() - 86400000), end: startOfToday },
      7: { start: new Date(startOfToday.getTime() - 6 * 86400000), end: endOfToday },
    };

    this.modificationsRange.set(ranges[daysToSubstract]);
    this.shownModifications.set(undefined);
  }

}
